import { Injectable } from "@angular/core";
import { IID_OL_ACQUISITO_KO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolAcquisitiKoStore } from "./acquisitiKo.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ACQUISIZIONE_NEGATIVA)
export class IIDolAcquisitiKoQuery extends AbstractInterfaceDataQuery<IID_OL_ACQUISITO_KO> {

  constructor(protected store: IIDolAcquisitiKoStore) {
    super(store);
  }
}
